<button [ngClass]="{
            staticColumnNote: true,
            infoMenuOpened: stickyNoteOpened
          }"
        [matMenuTriggerFor]="columnNoteMenu"
        [matMenuTriggerData]="{
            columnNoteData: {
              columnName: columnName,
              text: columnNote || null
            }
          }"
        mat-icon-button (click)="stickyNoteOpened=true">
  <mat-icon svgIcon="help_outline"></mat-icon>
</button>


<mat-menu class="columnNoteMenu" #columnNoteMenu="matMenu" xPosition="before"
          yPosition="below" (close)="stickyNoteOpened=false">
  <ng-template matMenuContent let-data="columnNoteData">
    <p id="columnNoteMenuHeader">{{data['columnName']}}</p>
    <p id="columnNoteMenuText">{{data['text']}}</p>
    @if (data['columnName'] === 'blackListedFields' || data['columnName'] === 'acceptedDifferences') {
      <a id="columnNoteMenuConfluenceLink"
         href="https://gxperts.atlassian.net/wiki/spaces/PD/pages/1475244/Address+List+Types+of+Status"
         target="_blank"
      >
        <span>Address List Types (Confluence)</span>
        <mat-icon inline svgIcon="open_in_new"></mat-icon>
      </a>
    }
  </ng-template>
</mat-menu>